import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@klickdata/core/auth';
import { FormHelper } from '@klickdata/core/form';
import { MobileService } from '@klickdata/core/mobile';
import { Resource, ResourceService } from '@klickdata/core/resource';
import { ResourceItem, ResourceItemService } from '@klickdata/core/resource-item';
import { Utils } from '@klickdata/core/util';
import { Observable, startWith, switchMap, tap } from 'rxjs';
import { ResourceItemDirective } from '../resource-item.directive';

import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MaterialParentDisplayModeBottomSheetComponent } from '@klickdata/shared-components/src/materials-manager-core/materials-manager-parent/material-parent-display-mode-bottom-sheet/material-parent-display-mode-bottom-sheet.component';

@Component({
    selector: 'app-resource-builder-material',
    templateUrl: './material.component.html',
    styleUrls: ['./material.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialComponent extends ResourceItemDirective implements OnChanges, OnDestroy {
    public resourceItems$: Observable<ResourceItem[]>;
    @Output() onViewResoureItem = new EventEmitter<ResourceItem>();
    @Input() currentIndex: number;
    Utils = Utils;

    constructor(
        protected resourceService: ResourceService,
        protected fb: FormBuilder,
        protected changeRef: ChangeDetectorRef,
        protected itemService: ResourceItemService,
        protected dialog: MatDialog,
        protected authService: AuthService,
        protected mobileService: MobileService,
        protected cdr: ChangeDetectorRef,
        protected bottomSheet: MatBottomSheet
    ) {
        super(resourceService, changeRef, dialog, authService, mobileService, bottomSheet);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.childGroup && !changes.childGroup.previousValue && changes.childGroup.currentValue) {
            this.childGroup.addControl('child_items', new FormArray([]), { emitEvent: false });
            this.resourceItems$ = this.onResourceExist.asObservable().pipe(
                startWith(null),
                switchMap(() => this.itemService.getResourceItems(this.childGroup.value.child_resource_id)),
                tap((items) => this.initChildItemsForm(items))
            );
        }
        if (changes.currentIndex) {
            this.currentIndex = changes.currentIndex.currentValue;
            this.cdr.markForCheck();
        }
    }

    selectResource(resource: Resource) {
        super.selectResource(resource);
    }

    /**
     * @override
     * @param resource
     * @param patch
     */
    protected afterResourceSelect() {
        const instructions = this.selected.instructions;
        if (!this.childGroup.value.instructions && instructions) {
            this.childGroup.patchValue({ instructions: instructions });
        }
    }

    initChildItemsForm(items: ResourceItem[]) {
        const itemsArray = this.childGroup.get('child_items') as FormArray;
        itemsArray.clear();
        items.forEach((item) => {
            itemsArray.push(this.createItemGroup(item), { emitEvent: false });
        });
        this.onViewResoureItem.emit(items[0]);
        FormHelper.resetForm(this.childGroup);
    }

    private createItemGroup(item: ResourceItem): FormGroup {
        return this.fb.group({
            id: item.id,
            can_download: item.can_download,
        });
    }

    toggleDownload(itemId: number, checked: boolean) {
        const itemsArray = this.childGroup.get('child_items') as FormArray;
        const index = itemsArray.controls.findIndex((control: FormGroup) => control.get('id').value === itemId);

        if (index !== -1) {
            const group = itemsArray.at(index) as FormGroup;
            group.patchValue({
                can_download: checked,
            });
            FormHelper.markForm(this.childGroup);
        }
    }
    showItem(item: ResourceItem) {
        this.bottomSheet.open(MaterialParentDisplayModeBottomSheetComponent, {
            data: {
                viewModeOnly: true,
                resourceItems: item.item_type_value === 'item_container' ? item.child_items : [item],
            },
        });
    }

    previousItem() {
        this.currentIndex--;
    }

    nextItem() {
        this.currentIndex++;
    }
}
